{
  "Choose Staff Metrics": "Choose Staff Metrics",
  "Edit Leaderboard": "Edit Leaderboard",
  "Manage Users or Devices": "Manage Users or Devices",
  "Showing results for {{filtersInfo}}": "Showing results for {{filtersInfo}}",
  "Some performance metrics are based on AI analysis of calls. Please click into each data point and review it before taking any action.": "Some performance metrics are based on AI analysis of calls. Please click into each data point and review it before taking any action.",
  "Staff Performance": "Staff Performance",
  "{{count}} Location, {{timePeriod}}_one": "{{count}} Location, {{timePeriod}}",
  "{{count}} Location, {{timePeriod}}_other": "{{count}} Locations, {{timePeriod}}",
  "{{count}} locations, {{timePeriod}}_one": "{{count}} locations, {{timePeriod}}",
  "{{count}} locations, {{timePeriod}}_other": "{{count}} locations, {{timePeriod}}"
}
